import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import ManualSimulators from './Index.vue';

export const routes = [
  {
    path: 'simuladores-manuais',
    name: 'talkvia_manual_simulators',
    meta: {
      permissions: ['administrator'],
      superAdminOnly: true,
    },
    featureFlag: FEATURE_FLAGS.TALKVIA_CORBAN_MANUAL_SIMULATORS,
    component: ManualSimulators,
  },
];
